import adminRoutes from '@/views/User/routers/admin'

const userRoutes: any = {
    path: '/u',
    name: 'user',
    meta: { title: 'navigation.projects-list' },
    component: () => import('@/views/User/User.vue'),
    redirect: { name: 'projects-list' },
    children: [
        adminRoutes,
        {
            path: 's',
            name: 'user-settings',
            component: () => import('@/views/User/views/Settings/views/Index.vue'),
            meta: {
                title: 'navigation.user-settings',
            },
            redirect: { name: 'general-settings' },
            children: [
                {
                    path: 'g',
                    name: 'general-settings',
                    component: () => import('@/views/User/views/Settings/views/General.vue'),
                    meta: {
                        title: 'navigation.user-settings',
                    },
                },
                {
                    path: 'c',
                    name: 'contact-settings',
                    component: () => import('@/views/User/views/Settings/views/Contact.vue'),
                    meta: {
                        title: 'navigation.user-settings',
                    },
                },
                {
                    path: 'n',
                    name: 'notification-settings',
                    component: () =>
                        import('@/views/User/views/Settings/views/NotificationsSettings.vue'),
                    meta: {
                        title: 'navigation.user-settings',
                    },
                },
                {
                    path: 'pw',
                    name: 'password-settings',
                    component: () => import('@/views/User/views/Settings/views/PasswordChange.vue'),
                    meta: {
                        title: 'navigation.user-settings',
                    },
                },
            ],
        },
        {
            path: '',
            name: 'projects-list',
            meta: { title: 'navigation.projects-list' },
            component: () => import('@/views/User/views/MyProjects/views/MyProjects.vue'),
        },
    ],
}

export default userRoutes
